import type { ShowConfirmationEvent } from '~/features/confirmation/events';

/** [MCV-1850] Declining always asks first: the other party is notified and the row leaves the default list. */
export const declineResponseConfirmation = (onConfirm: () => void): ShowConfirmationEvent => ({
  type: 'ON_SHOW_CONFIRMATION',
  payload: {
    title: 'Decline Response',
    message:
      'Decline this response? The other party will be notified and it will move to your declined responses.',
    confirmLabel: 'Decline',
    onConfirm,
  },
});

export const withdrawResponseConfirmation = (onConfirm: () => void): ShowConfirmationEvent => ({
  type: 'ON_SHOW_CONFIRMATION',
  payload: {
    title: 'Withdraw Response',
    message: 'Withdraw this response? The other party will be notified.',
    confirmLabel: 'Withdraw',
    onConfirm,
  },
});

export const RESPONSE_DECLINED_ALERT_TEXT = 'Response declined';
